<!-- Printer Settings Modal -->
<div
  *ngIf="showModal"
  class="fixed inset-0 z-50 overflow-y-auto"
  (click)="onBackdropClick($event)"
>
  <div class="flex items-end md:items-center justify-center min-h-screen px-4 py-4 md:py-8">
    <div
      class="bg-white/95 dark:bg-luxury-navy/95 backdrop-blur-xl rounded-t-3xl md:rounded-3xl shadow-luxury w-full max-w-md max-h-[90vh] overflow-y-auto border-t md:border border-gray-200/50 dark:border-primary-800/20 animate-slide-up md:animate-scale-in"
      (click)="$event.stopPropagation()"
    >
      <div class="sticky top-0 bg-white/95 dark:bg-luxury-navy/95 backdrop-blur-xl border-b border-gray-200/50 dark:border-primary-800/20 px-6 py-4 flex items-center justify-between">
        <h2 class="text-xl font-bold text-gray-900 dark:text-white">Printer Settings</h2>
        <button type="button"
          (click)="closeModal()"
          class="p-2 rounded-xl hover:bg-gray-100 dark:hover:bg-white/5 transition-all duration-200 active:scale-95 touch-manipulation"
          aria-label="Close modal">
          <svg class="w-6 h-6 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <div class="p-6 space-y-6">
        <div class="space-y-3">
          <p class="text-sm font-semibold text-gray-700 dark:text-gray-300">Print Formats</p>
          <div class="flex items-center justify-between gap-4 p-4 rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-white/5">
            <div class="min-w-0">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">Thermal (2″ / 3″)</p>
              <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">Receipt printer and labels</p>
            </div>
            <label class="relative inline-flex flex-shrink-0 cursor-pointer">
              <input type="checkbox" class="sr-only peer" [checked]="thermalEnabled" (change)="onThermalEnabledToggle($event)" />
              <span class="w-11 h-6 bg-gray-300 peer-checked:bg-primary-600 rounded-full relative transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-transform peer-checked:after:translate-x-5"></span>
            </label>
          </div>
          <div class="flex items-center justify-between gap-4 p-4 rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-white/5">
            <div class="min-w-0">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">A4 Print &amp; PDF</p>
            </div>
            <label class="relative inline-flex flex-shrink-0 cursor-pointer">
              <input type="checkbox" class="sr-only peer" [checked]="a4Enabled" (change)="onA4EnabledToggle($event)" />
              <span class="w-11 h-6 bg-gray-300 peer-checked:bg-primary-600 rounded-full relative transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-transform peer-checked:after:translate-x-5"></span>
            </label>
          </div>
          <div class="flex items-center justify-between gap-4 p-4 rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-white/5">
            <div class="min-w-0">
              <p class="text-sm font-semibold text-gray-900 dark:text-white">A5 Print &amp; PDF</p>
            </div>
            <label class="relative inline-flex flex-shrink-0 cursor-pointer">
              <input type="checkbox" class="sr-only peer" [checked]="a5Enabled" (change)="onA5EnabledToggle($event)" />
              <span class="w-11 h-6 bg-gray-300 peer-checked:bg-primary-600 rounded-full relative transition-colors after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:w-5 after:h-5 after:bg-white after:rounded-full after:transition-transform peer-checked:after:translate-x-5"></span>
            </label>
          </div>
        </div>

        <div *ngIf="thermalEnabled" class="space-y-6">
        <!-- Paper Size -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Paper Size</label>
          <div class="grid grid-cols-2 gap-3">
            <button type="button"
              (click)="paperSize = '2inch'"
              [class.bg-primary-600]="paperSize === '2inch'"
              [class.text-white]="paperSize === '2inch'"
              [class.bg-gray-100]="paperSize !== '2inch'"
              [class.text-gray-700]="paperSize !== '2inch'"
              class="px-4 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 active:scale-95 touch-manipulation min-h-[40px] dark:bg-white/5 dark:text-gray-300">
              2-inch (32 chars)
            </button>
            <button type="button"
              (click)="paperSize = '3inch'"
              [class.bg-primary-600]="paperSize === '3inch'"
              [class.text-white]="paperSize === '3inch'"
              [class.bg-gray-100]="paperSize !== '3inch'"
              [class.text-gray-700]="paperSize !== '3inch'"
              class="px-4 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 active:scale-95 touch-manipulation min-h-[40px] dark:bg-white/5 dark:text-gray-300">
              3-inch (48 chars)
            </button>
          </div>
        </div>

        <!-- Product label printer (50×25mm roll) -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
            Product Labels ({{ labelWidthMm }}mm × {{ labelHeightMm }}mm, {{ labelGapMm }}mm gap)
          </label>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">
            Roll: <strong>50×25mm</strong> labels, <strong>3mm</strong> gap. Press <strong>FEED</strong> once before printing so the first sticker is at the top.
            <strong>POSIFLOW:</strong> use <strong>ESC/POS</strong>. If only numbers print, try <strong>TSPL</strong>.
          </p>
          <div class="grid grid-cols-2 gap-3 mt-3">
            <button type="button"
              (click)="labelProtocol = 'escpos'"
              [class.bg-primary-600]="labelProtocol === 'escpos'"
              [class.text-white]="labelProtocol === 'escpos'"
              [class.bg-gray-100]="labelProtocol !== 'escpos'"
              [class.text-gray-700]="labelProtocol !== 'escpos'"
              class="px-4 py-3 rounded-xl font-medium transition-all duration-200 min-h-[40px] dark:bg-white/5 dark:text-gray-300">
              ESC/POS (POSIFLOW)
            </button>
            <button type="button"
              (click)="labelProtocol = 'tspl'"
              [class.bg-primary-600]="labelProtocol === 'tspl'"
              [class.text-white]="labelProtocol === 'tspl'"
              [class.bg-gray-100]="labelProtocol !== 'tspl'"
              [class.text-gray-700]="labelProtocol !== 'tspl'"
              class="px-4 py-3 rounded-xl font-medium transition-all duration-200 min-h-[40px] dark:bg-white/5 dark:text-gray-300">
              TSPL (TSC/Xprinter)
            </button>
          </div>
          <div class="mt-3" *ngIf="labelProtocol === 'escpos'">
            <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">
              Label feed fine-tune (mm): {{ labelFeedOffsetMm }}
            </label>
            <input type="range" min="-3" max="3" step="0.5" [(ngModel)]="labelFeedOffsetMm"
              class="w-full accent-primary-600" />
            <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
              Each label feeds <strong>{{ labelPitchDots }} dots</strong> (200 label + 24 gap). Fine-tune only if a slight shift remains after testing 2–3 labels.
            </p>
          </div>
        </div>

        <!-- Connection Type -->
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">Connection Type</label>
          <div class="space-y-2">
            <button type="button"
              (click)="connectionType = 'bluetooth'"
              [class.bg-primary-600]="connectionType === 'bluetooth'"
              [class.text-white]="connectionType === 'bluetooth'"
              [class.bg-gray-100]="connectionType !== 'bluetooth'"
              [class.text-gray-700]="connectionType !== 'bluetooth'"
              class="w-full px-4 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 active:scale-95 touch-manipulation min-h-[40px] text-left flex items-center justify-between dark:bg-white/5 dark:text-gray-300">
              <span>Bluetooth</span>
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.141 0M1.394 9.393c5.857-5.857 15.355-5.857 21.213 0"></path>
              </svg>
            </button>
            <button type="button"
              (click)="connectionType = 'usb'"
              [class.bg-primary-600]="connectionType === 'usb'"
              [class.text-white]="connectionType === 'usb'"
              [class.bg-gray-100]="connectionType !== 'usb'"
              [class.text-gray-700]="connectionType !== 'usb'"
              class="w-full px-4 py-3 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 active:scale-95 touch-manipulation min-h-[40px] text-left flex items-center justify-between dark:bg-white/5 dark:text-gray-300">
              <span>USB / Serial</span>
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
              </svg>
            </button>
          </div>
        </div>

        <!-- Test Connection Button -->
        <div class="space-y-3">
          <button type="button"
            (click)="testConnection()"
            [disabled]="isConnecting || !thermalEnabled"
            class="w-full px-4 py-2 rounded-lg bg-gray-100 dark:bg-white/5 hover:bg-gray-200 dark:hover:bg-white/10 text-gray-700 dark:text-gray-300 font-semibold transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-soft touch-manipulation min-h-[40px] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center">
            <span *ngIf="!isConnecting" class="flex items-center">
              <svg class="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              Test Connection
            </span>
            <span *ngIf="isConnecting" class="flex items-center">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Connecting...
            </span>
          </button>

          <div *ngIf="connectionType === 'usb' || connectionType === 'serial'" class="grid grid-cols-2 gap-3">
            <button type="button"
              (click)="selectNewPort()"
              [disabled]="isConnecting || !thermalEnabled"
              class="px-4 py-3 rounded-xl bg-amber-50 dark:bg-amber-900/20 hover:bg-amber-100 dark:hover:bg-amber-900/30 text-amber-700 dark:text-amber-300 font-semibold transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-soft touch-manipulation min-h-[40px] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center border border-amber-200 dark:border-amber-800">
              <span class="flex items-center text-sm">
                <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                Select New
              </span>
            </button>

            <button type="button"
              (click)="clearSavedConnection()"
              [disabled]="isConnecting || !thermalEnabled"
              class="px-4 py-3 rounded-xl bg-red-50 dark:bg-red-900/20 hover:bg-red-100 dark:hover:bg-red-900/30 text-primary-600 dark:text-primary-400 font-semibold transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-soft touch-manipulation min-h-[40px] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none flex items-center justify-center border border-red-200 dark:border-red-800">
              <span class="flex items-center text-sm">
                <svg class="w-4 h-4 mr-1.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                </svg>
                Clear Saved
              </span>
            </button>
          </div>
        </div>

        <!-- Info Message -->
        <div class="p-4 rounded-xl border"
             [ngClass]="connectionType === 'bluetooth' ? 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800' : 'bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800'">
          <div *ngIf="connectionType === 'bluetooth'">
            <p class="text-xs text-red-800 dark:text-red-300 mb-2 flex items-start">
              <svg class="w-4 h-4 mr-1 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
              <strong>100% Driver-Free!</strong> No software installation needed.
            </p>
            <p class="text-xs text-red-700 dark:text-red-400 mb-2 font-semibold">📱 Quick Setup (2 steps):</p>
            <ol class="text-xs text-red-700 dark:text-red-400 list-decimal list-inside space-y-1 mb-2">
              <li><strong>Pair in Windows:</strong> Settings → Bluetooth & devices → Add device → Select your printer</li>
              <li><strong>Connect in App:</strong> Click "Test Connection" below → Select printer → Click Connect</li>
            </ol>
          </div>
          <div *ngIf="connectionType === 'usb'">
            <p class="text-xs text-blue-800 dark:text-blue-300 mb-2"><strong>USB/Serial Connection</strong> - Auto-reconnects after first setup!</p>
          </div>
          <p class="text-xs text-gray-600 dark:text-gray-400 mt-2 pt-2 border-t"
             [ngClass]="connectionType === 'bluetooth' ? 'border-red-200 dark:border-red-800' : 'border-blue-200 dark:border-blue-800'">
            <strong>Browser:</strong> Requires Chrome or Edge browser
          </p>
        </div>
        </div>

        <!-- A5 Bill Columns (for A5 print & PDF only) -->
        <div *ngIf="a5Enabled">
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-3">A5 Bill Columns</label>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Select which columns appear on A5 print and PDF download.</p>
          <div class="grid grid-cols-2 gap-2">
            <label *ngFor="let col of a5ColumnOptions"
                   class="flex items-center gap-2 px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer">
              <input type="checkbox"
                     [checked]="a5BillColumns[col.key] !== false"
                     (change)="toggleA5Column(col.key)"
                     class="rounded border-gray-300 dark:border-gray-500 text-primary-600 focus:ring-primary-500">
              <span class="text-sm font-medium text-gray-700 dark:text-gray-300">{{ col.label }}</span>
            </label>
          </div>
        </div>
        </div>

        <!-- A4 Bill Columns (for A4 print & PDF; default all on) -->
        <div *ngIf="a4Enabled">
        <div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A4 GST Invoice Columns</label>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Select columns for A4 GST invoice. By default all are on.</p>
          <div class="grid grid-cols-2 gap-2 max-h-32 overflow-y-auto mb-3">
            <label *ngFor="let col of a4GstColumnOptions"
                   class="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer">
              <input type="checkbox"
                     [checked]="a4GstBillColumns[col.key]"
                     (change)="toggleA4GstColumn(col.key)"
                     class="rounded border-gray-300 dark:border-gray-500 text-primary-600 focus:ring-primary-500">
              <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ col.label }}</span>
            </label>
          </div>
          <label class="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">A4 Non-GST Estimate Columns</label>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Select columns for A4 Non-GST estimate. By default all are on.</p>
          <div class="grid grid-cols-2 gap-2">
            <label *ngFor="let col of a4NonGstColumnOptions"
                   class="flex items-center gap-2 px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-white/5 cursor-pointer">
              <input type="checkbox"
                     [checked]="a4NonGstBillColumns[col.key]"
                     (change)="toggleA4NonGstColumn(col.key)"
                     class="rounded border-gray-300 dark:border-gray-500 text-primary-600 focus:ring-primary-500">
              <span class="text-xs font-medium text-gray-700 dark:text-gray-300">{{ col.label }}</span>
            </label>
          </div>
        </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200/50 dark:border-primary-800/20">
          <button type="button"
            (click)="closeModal()"
            class="flex-1 px-4 py-2 rounded-lg bg-gray-100 dark:bg-white/5 hover:bg-gray-200 dark:hover:bg-white/10 text-gray-700 dark:text-gray-300 font-semibold transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-soft touch-manipulation min-h-[40px]">
            Cancel
          </button>
          <button type="button"
            (click)="saveSettings()"
            class="flex-1 px-4 py-2 rounded-lg bg-gradient-to-r from-primary-600 to-primary-700 dark:from-primary-600 dark:to-primary-800 hover:from-primary-700 hover:to-primary-800 dark:hover:from-primary-700 dark:hover:to-primary-900 text-white font-semibold transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-luxury-gold touch-manipulation min-h-[40px]">
            Save Settings
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
